import * as actionTypes from "../actionTypes";

// get territories list
export const getTerritoriesList = (data) => {
  return {
    type: actionTypes.GET_TERRITORIES_LIST_START,
    payload: data,
  };
};
export const getTerritoriesListSuccess = (data) => {
  return {
    type: actionTypes.GET_TERRITORIES_LIST_SUCCESS,
    payload: data,
  };
};
export const getTerritoriesListFailure = (data) => {
  return {
    type: actionTypes.GET_TERRITORIES_LIST_FAILURE,
    payload: data,
  };
};

// get licensed territories list
export const getLicensedTerritoriesList = (data) => {
  return {
    type: actionTypes.GET_LICENSED_TERRITORIES_LIST_START,
    payload: data,
  };
};
export const getLicensedTerritoriesListSuccess = (data) => {
  return {
    type: actionTypes.GET_LICENSED_TERRITORIES_LIST_SUCCESS,
    payload: data,
  };
};
export const getLicensedTerritoriesListFailure = (data) => {
  return {
    type: actionTypes.GET_LICENSED_TERRITORIES_LIST_FAILURE,
    payload: data,
  };
};

export const addTerritory = (data) => {
  return {
    type: actionTypes.ADD_TERRITORY_START,
    payload: data,
  };
};

export const deleteTerritory = (data) => {
  return {
    type: actionTypes.DELETE_TERRITORY_START,
    payload: data,
  };
};
export const addTerritorySuccess = (data) => {
  let d = { success: data?.message||'success'}
  return {
    type: actionTypes.ADD_TERRITORY_SUCCESS,
    payload: d,
  };
};
export const addTerritoryFailure = (data) => {
  console.log(data)
  let d = { error:data?.error|| 'content not created '}
  return {
    type: actionTypes.ADD_TERRITORY_FAILURE,
    payload: d,
  };
};
export const territoryMessageHandler = () => {
  return {
    type: actionTypes.TERRITORY_MESSAGE_HANDLER,
    payload: null,
  };
};
